import { axios, createFormData, handleError } from '../axios';

export const addCategory = (data) => {
  return new Promise((resolve) => {
    axios
      .post('admin/category/add', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
